import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async action to fetch registered users with pagination and filters
export const fetchRegisteredUsers = createAsyncThunk(
  'registerUser/fetchRegisteredUsers',
  async ({ page, limit = 8, username, email, createdAt, sort = "DESC" }) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (limit) params.append("limit", limit);
    if (username) params.append("username", username);
    if (email) params.append("email", email);
    if (createdAt) params.append("createdAt", createdAt);
    if (sort) params.append("sort", sort);

    const response = await axios.get(`/api/v1/register-user-list?${params.toString()}`, { withCredentials: true });

    console.log("Fetched Users:", response.data);
    return response.data; // Assuming response contains { data: users, totalPages, totalUsers, currentPage }
  }
);
// Async action to create a new user
export const createUser = createAsyncThunk(
  'registerUser/createUser',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/v1/create-user', userData, { withCredentials: true });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'User creation failed');
    }
  }
);
const registerUserSlice = createSlice({
  name: 'registerUser',
  initialState: {
    registeredUsers: [],
    totalPages: 1,
    currentPage: 1,
    totalUsers: 0,
    filters: {
      username: "",
      email: "",
      createdAt: "",
      sort: "DESC",
    },
    status: 'idle',
    error: null,
    createStatus: 'idle',
    createError: null,
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users
      .addCase(fetchRegisteredUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchRegisteredUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.registeredUsers = action.payload.data || [];
        state.totalPages = action.payload.totalPages ?? state.totalPages; // Keep previous if missing
        state.totalUsers = action.payload.totalUsers ?? state.totalUsers; // Preserve total count
        state.currentPage = action.payload.currentPage ?? state.currentPage; // Keep previous page
      })
      .addCase(fetchRegisteredUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })

      // Create User
      .addCase(createUser.pending, (state) => {
        state.createStatus = 'loading';
        state.createError = null;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.createStatus = 'succeeded';
        // if (Array.isArray(state.registeredUsers)) {
        //   state.registeredUsers.push(action.payload); // Add new user safely
        // }
      })
      .addCase(createUser.rejected, (state, action) => {
        state.createStatus = 'failed';
        state.createError = action.payload;
      });
  },
});

export const { setCurrentPage, setFilters } = registerUserSlice.actions;
export default registerUserSlice.reducer;
